module.exports = "/_next/static/images/26b0195bd126a0b9adfa16f1d5f4b6da-shield-circle.svg.webp";